<script>
import {defineComponent} from 'vue'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {useCalculatorStore} from "@js/store/CalculatorStore.js";


export default defineComponent({
    name: "CalculatorNav",
    components: {Swiper, SwiperSlide},
    data() {
        return {
            swiper: null,
            breakpoints: {
                320: {slidesPerView: 1.2, spaceBetween: 10, loop: true},
                640: {slidesPerView: 2.2, spaceBetween: 15, loop: true},
                1024: {slidesPerView: 3, spaceBetween: 15},
                1400: {slidesPerView: 3, spaceBetween: 20},
            },
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance
        },
        slideNext() {
            this.swiper?.slideNext()
        },
        slidePrev() {
            this.swiper?.slidePrev()
        },
    },
    setup() {
        const calculatorStore = useCalculatorStore()

        return {calculatorStore}
    }
})
</script>

<template>
    <div class="relative">
        <Swiper :loop="false" :breakpoints="breakpoints" @swiper="setSwiper" class="pagination-base">
            <SwiperSlide v-for="(item, type) in calculatorStore.calc_types" :key="type">
                <div @click.prevent="calculatorStore.setType(type)"
                     class="border-2 rounded-lg overflow-hidden group p-5 cursor-pointer md:hover:border-baseColor max-md:active:border-baseColor transition flex items-center justify-center font-bold text-nowrap"
                     :class="{'border-baseColor': calculatorStore.calc_type === type, 'border-gray-300': calculatorStore.calc_type !== type}">
                    <div class="flex items-center gap-2 leading-none">
                        <component :is="item.icon" class="w-6 h-6"/>
                        {{ item.btn_title }}
                    </div>
                </div>
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<style scoped lang="scss">

</style>
